import { ProgressIndicator } from '~/components/progress-indicator'
import { type ScopedProps, useSnackbarContext } from '../../snackbar'
import { progressIndicatorMapper } from '../../utils/progress-indicator-mapper'
import * as Comp from './timer-bar.styles'

type TimerBarProps = {
  testID?: string
}

export function TimerBar(props: TimerBarProps) {
  const { __scopeSnackbar, testID } = props as ScopedProps<TimerBarProps>

  const { percentage, type = 'brand-accent' } = useSnackbarContext(
    'TimerBar',
    __scopeSnackbar
  )

  return (
    <Comp.Root testID={testID}>
      <ProgressIndicator
        percentage={percentage}
        size="nano"
        variant={progressIndicatorMapper(type)}
        bgTransparent
        testID={`${testID}-progress-indicator`}
      />
    </Comp.Root>
  )
}
